import { apiSlice } from "./apiSlice";
const userurl = `${process.env.REACT_APP_BASE_URL}/api/v1/auth`;

export const UserApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        //    getChats:builder.query({
        //     query:(userId)=>({
        //         url:`${chat_url}/${userId}`,
        //         method:'Get',
        //     }),
        //     providesTags: ['conversations']
        //    }),
        //    sendMessage:builder.mutation({
        //     query:(data)=> ({
        //         url: `${chat_url}/messages`,
        //         method:"POST",
        //         body:data
        //     }),
        //     invalidatesTags: ['conversations']
        //     })
        register: builder.mutation({
            query: (data) => ({
                url: `${userurl}/register`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['users']
        }),
        login: builder.mutation({
            query: (data) => ({
                url: `${userurl}/login`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['users']
        }),
        getUserProfile: builder.query({
            query: () => ({
                url: `${userurl}/profile`,
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }),
            providesTags: ['users']
        }),
        userLogout: builder.mutation({
            query: (token) => ({
                url: `${userurl}/logout`,
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }),
            invalidatesTags: ['users']
        }),
        getAllUsers: builder.query({
            query: () => ({
                url: `${userurl}/get-users`,
                method: 'GET',
            }),
            providesTags: ['users']
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `${userurl}/delete-user/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['users']
        }),
        updateUser: builder.mutation({
            query: ({ id, data }) => ({
                url: `${userurl}/update-user/${id}`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['users']
        }),
        updateUserStatus: builder.mutation({
            query: (id) => ({
                url: `${userurl}/update-user-status/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ['users']
        }),
        createRoleAndPermission: builder.mutation({
            query: (data) => ({
                url: `${userurl}/create-role`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['roles']
        }),
        getRolesAndPermissions: builder.query({
            query: () => ({
                url: `${userurl}/get-roles`,
                method: 'GET',
            }),
            providesTags: ['roles']
        }),
    }),

})

export const { useRegisterMutation, useLoginMutation, useUserLogoutMutation, useCreateRoleAndPermissionMutation, useGetRolesAndPermissionsQuery, useGetUserProfileQuery, useGetAllUsersQuery, useDeleteUserMutation, useUpdateUserMutation, useUpdateUserStatusMutation } = UserApiSlice
